import React from 'react';
import AppLayout from '../components/app/AppLayout';
import MicroResets from '../components/app/MicroResets';

function FlashesPage() {
  return (
    <AppLayout>
      <MicroResets />
    </AppLayout>
  );
}

export default FlashesPage;







